/** @jsxImportSource @emotion/react */

import React, { useEffect, useState, useMemo } from 'react';
import { css } from '@emotion/react';
import { connect } from 'unistore/react';
import { If, Then, Else, LoaderPuff } from '@buyhatke/react-ui';

import { coinsActions } from '@utils/store/actions';
import { Button } from '@components';

import {
	getCoinProps,
	coinsListWithNames,
	getNetworkProps,
} from '@utils/params';

import { isDisabledDepo, isDisabledWith } from '@utils/storeUtils';
import {
	decimalTrimmer2,
	debounce,
	startSearchInstance,
} from '@utils/customLib';
import { allDynamicFee } from '@utils/cred';
import SearchBox from './searchBox';

const CoinRow = ({ coin, withdrawCoins, ...restProps }) => {
	const {
		coinName,
		coinId,
		withdrawalFee = '-',
		minWithMultiplier,
		minimumWithdrawal,
		floatPlaces,
		networks,
		networkName,
		...restCoinProps
	} = getCoinProps(coin);

	const disabledDepo = isDisabledDepo(coin);
	const disabledWith = isDisabledWith(coin);

	if (coin === 'ram') {
		return (
			<tr>
				<td className="py-8 px-4 md:px-8 font-semibold">EOS RAM</td>
				<td> </td>
				<td className="py-8 px-4 md:px-8">
					0.5% (Blockhain Fee) + 0.25% (Bitbns Fee)
				</td>
				<td>{/* {minimumWithdrawal} */}</td>
			</tr>
		);
	}

	return (
		<tr className="border-b border-gray-200">
			<td className="py-8 px-4 md:px-8 font-semibold">
				{coinName} (<span className="uppercase">{coin}</span>)
			</td>
			<td>
				<If condition={withdrawCoins.includes(coin)}>
					<Then>
						{networks ? (
							networks.map(nw => {
								if (nw === 6) {
									return (
										<p key={nw} className="pb-8">
											{networkName.toUpperCase()}
										</p>
									);
								}
								const { shortName } = getNetworkProps(nw);
								return (
									<p key={nw} className="pb-8">
										{shortName.toUpperCase()}
									</p>
								);
							})
						) : networkName ? (
							<p className="pb-8">{networkName.toUpperCase()}</p>
						) : null}
					</Then>
					<Else>
						<p className="pb-8">-</p>
					</Else>
				</If>
			</td>
			<td className="py-8 px-4 md:px-8">
				<If condition={withdrawCoins.includes(coin)}>
					<Then>
						{networks ? (
							networks.map(nw => {
								if (nw === 6) {
									return (
										<p key={nw} className="pb-8">
											{withdrawalFee}
										</p>
									);
								}
								const { shortName, dynamicWithFee } =
									getNetworkProps(nw);

								if (dynamicWithFee) {
									return restProps[`fee_${shortName}`] ? (
										<p key={nw} className="pb-8">
											{
												restProps[`fee_${shortName}`][
													coinId
												]
											}
										</p>
									) : (
										<p key={nw} className="pb-8">
											0
										</p>
									);
								}

								return (
									<p key={nw} className="pb-8">
										{restCoinProps[shortName]
											?.withdrawalFee ?? withdrawalFee}
									</p>
								);
							})
						) : (
							<p className="pb-8">{withdrawalFee}</p>
						)}
					</Then>
					<Else>
						<p className="pb-8">-</p>
					</Else>
				</If>
			</td>
			<td className="py-8 px-4 md:px-6">
				<If condition={withdrawCoins.includes(coin)}>
					<Then>
						{networks ? (
							networks.map(nw => {
								if (nw === 6) {
									return (
										<p key={nw} className="pb-8">
											{minimumWithdrawal}
										</p>
									);
								}
								const {
									shortName,
									dynamicWithFee,
									minWithMultiplier,
								} = getNetworkProps(nw);

								if (dynamicWithFee) {
									const fee = restProps[`fee_${shortName}`]
										? restProps[`fee_${shortName}`][coinId]
										: 0;

									let dynamicMinWith = Number(
										decimalTrimmer2(
											(fee *
												1000000 *
												minWithMultiplier) /
												1000000,
											floatPlaces
										)
									);

									if (fee === dynamicMinWith) {
										dynamicMinWith +=
											10 ** (-1 * floatPlaces);
									}

									return (
										<p key={nw} className="pb-8">
											{dynamicMinWith}
										</p>
									);
								}

								return (
									<p key={nw} className="pb-8">
										{restCoinProps[shortName]
											?.minimumWithdrawal ??
											minimumWithdrawal}
									</p>
								);
							})
						) : (
							<p className="pb-8">{minimumWithdrawal}</p>
						)}
					</Then>
					<Else>
						<p className="pb-8">-</p>
					</Else>
				</If>
				{/* <If condition={dynamicWithFee}>
					<Then>
						<If
							condition={
								(fee_matic && fee_matic[coinId]) ||
								(fee_bep && fee_bep[coinId])
							}
						>
							<Then>
								{fee_matic && fee_matic[coinId] && (
									<p className="pb-8">
										{Number(
											decimalTrimmer2(
												(fee_matic[coinId] *
													1000000 *
													minWithMultiplier) /
													1000000,
												floatPlaces
											)
										)}
									</p>
								)}
								{fee_bep && fee_bep[coinId] && (
									<p>
										{Number(
											decimalTrimmer2(
												(fee_bep[coinId] *
													1000000 *
													minWithMultiplier) /
													1000000,
												floatPlaces
											)
										)}
									</p>
								)}
							</Then>
							<Else>{withdrawalFee}</Else>
						</If>
					</Then>
					<Else>{minimumWithdrawal || '-'}</Else>
				</If> */}
			</td>
			<td className="py-8 px-2">
				{/* <div
														className="rounded-full h-4 w-4 bg-redOrangified mx-auto"
														title="Disabled"
													/> */}
				<Button
					size="vtiny"
					variant="minimal"
					className={`inline-block tracking-widest ${
						disabledDepo
							? 'bg-gray-300 hover:bg-gray-400'
							: 'bg-purple-200 hover:bg-purple-300'
					}`}
					link={`/trade/#/crypto-deposit/${coin}`}
					disabled={disabledDepo}
				>
					{disabledDepo ? 'Disabled' : 'Enabled'}
				</Button>
			</td>
			<td className="py-8 px-2">
				<Button
					size="vtiny"
					variant="minimal"
					className={`inline-block tracking-widest ${
						disabledWith
							? 'bg-gray-300 hover:bg-gray-400'
							: 'bg-purple-200 hover:bg-purple-300'
					}`}
					link={`/trade/#/crypto-deposit/${coin}`}
					disabled={disabledWith}
				>
					{disabledWith ? 'Disabled' : 'Enabled'}
				</Button>
			</td>
		</tr>
	);
};

const Fees = ({
	balanceCoins = [],
	withdrawCoins = [],
	fdContext = {
		fee_erc20: {},
		fee_bep20: {},
		fee_matic20: {},
	},
}) => {
	const sortedBalance = useMemo(() => {
		const justSwap = [];
		const listed = [];

		balanceCoins.forEach(c => {
			if (withdrawCoins.includes(c)) {
				listed.push(c);
			} else {
				justSwap.push(c);
			}
		});

		listed.sort();
		justSwap.sort();

		return [...listed, ...justSwap];
	}, [balanceCoins, withdrawCoins]);
	const [feeData, setFd] = useState(fdContext);

	const [filterCoinList, setFilterCoinList] = useState(sortedBalance);

	const [isLoading, setIsLoading] = useState(false);
	const [showAll, setShowAll] = useState(false);

	useEffect(() => {
		allDynamicFee().then(({ status, data, data_bsc, data_matic }) => {
			if (status === 1) {
				const allFees = {
					fee_erc20: data,
					fee_bep20: data_bsc,
					fee_matic20: data_matic,
				};
				setFd(allFees);
				setFilterCoinList(sortedBalance);
				setIsLoading(false);
			}
		});
	}, [balanceCoins]);

	const renderSearchText = debounce(text => {
		const searchedText = text !== undefined ? text.toLowerCase() : '';

		if (text === '') {
			setFilterCoinList(sortedBalance);
		} else {
			const { newList } = startSearchInstance(
				sortedBalance,
				coinsListWithNames,
				searchedText
			);

			setFilterCoinList(newList);
		}
	}, 250);

	const { fee_erc20, fee_bep20, fee_matic20 } = feeData;

	return (
		<section className="relative">
			<h2 className="text-xl font-bold my-4">Withdrawal Fees</h2>

			<SearchBox onSearch={renderSearchText} />

			<If
				condition={
					!isLoading && (fee_erc20 || fee_bep20 || fee_matic20)
				}
			>
				<Then>
					<div
						css={css`
							overflow: auto;
							@media (min-width: 768px) {
								overflow: unset;
							}
						`}
					>
						<table className="c-table c-table--smallFont c-table--fullWidth border-gray-200 text-left">
							<thead className="border-b border-gray-200 text-gray-800 text-xs xs:text-sm relative">
								<tr>
									<th className="py-8 px-4 md:px-8 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10">
										Token
									</th>
									<th className="py-8 px-4 md:px-8 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10">
										Network
									</th>
									<th className="py-8 px-4 md:px-8 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10">
										FEE
									</th>
									<th className="py-8 px-4 md:px-6 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10">
										Min Withdrawal Amt
									</th>
									<th className="py-8 px-2 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10 text-center">
										Deposit
									</th>
									<th className="py-8 px-2 font-normal whitespace-nowrap md:sticky top-0 bg-white z-10 text-center">
										Withdrawal
									</th>
								</tr>
							</thead>
							<tbody className="align-baseline text-gray-900">
								{filterCoinList.length > 0 &&
									(showAll
										? filterCoinList
										: filterCoinList.slice(0, 30)
									).map(coin => (
										<CoinRow
											coin={coin}
											fee_erc20={fee_erc20}
											fee_matic20={fee_matic20}
											fee_bep20={fee_bep20}
											key={coin}
											withdrawCoins={withdrawCoins}
										/>
									))}
							</tbody>
						</table>
						<If condition={showAll}>
							<Else>
								<div className="my-6 flex items-center justify-center">
									<Button
										variant="outline"
										triangle="bottom"
										onClick={() => {
											setShowAll(true);
										}}
									>
										Show All
									</Button>
								</div>
							</Else>
						</If>
					</div>
				</Then>
				<Else>
					<LoaderPuff
						stroke="#8708d7"
						height="80"
						className="align-middle flex mx-auto my-32"
					/>
				</Else>
			</If>
		</section>
	);
};

export default connect('balanceCoins, withdrawCoins', coinsActions)(Fees);
